// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-shell {
  width: 100%;
  min-height: 100vh;
}

:root {
  --bg-body: #f3f4f6;
  --bg-shell: #ffffff;
  --bg-card: #ffffff;
  --bg-muted: #f9fafb;
  --border-subtle: #e5e7eb;
  --primary: #2563eb;
  --primary-soft: #dbeafe;
  --primary-strong: #1d4ed8;
  --danger: #ef4444;
  --text-main: #111827;
  --text-muted: #6b7280;
  --radius-lg: 16px;
  --radius-md: 12px;
  --shadow-soft: 0 18px 45px rgba(15, 23, 42, 0.1);

  --font-base: 14px;
  --font-scale: 1;
}

/* 폰트 크기 모드 (A-, A, A+) */
[data-font-size="sm"] {
  --font-scale: 0.9;
}
[data-font-size="md"] {
  --font-scale: 1;
}
[data-font-size="lg"] {
  --font-scale: 1.1;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  background: linear-gradient(180deg, #f9fafb, #eff6ff);
  min-height: 100vh;
  color: var(--text-main);
}

/* ========================================
   로딩 오버레이
   ======================================== */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.loading-overlay.show {
  display: flex;
}

.loading-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-text {
  position: absolute;
  margin-top: 100px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

/* 공통 버튼 스타일 */
button {
  border: none;
  cursor: pointer;
  font-size: 12px;
  border-radius: 999px;
  padding: 6px 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: #e5e7eb;
  color: #111827;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease,
    transform 0.05s ease;
}

button:hover {
  background: #d1d5db;
}

button:active {
  transform: translateY(1px);
}

.btn-primary {
  background: var(--primary);
  color: #ffffff;
}

.btn-primary:hover {
  background: var(--primary-strong);
  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.35);
}

.btn-ghost {
  background: transparent;
  color: var(--text-muted);
}

/* 칩 / 배지 */
.chip {
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 11px;
  background: #eff6ff;
  color: #1d4ed8;
}

.chip-green {
  background: #ecfdf3;
  color: #15803d;
}

.chip-gray {
  background: #f3f4f6;
  color: #4b5563;
}

.chip-blue {
  background: #dbeafe;
  color: #1e40af;
}

/* 앱 쉘: 프레임 없이 전체 화면 사용 */
.app-shell {
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  background: var(--bg-shell);
  border-radius: 0;
  box-shadow: none;
  display: flex;
  flex-direction: column;
}

/* 로그인 뷰 (화면 중앙 카드) */
.login-view {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #dbeafe, #fef9c3);
}

.login-card {
  width: 360px;
  border-radius: 20px;
  padding: 24px 24px 20px;
  background: #ffffff;
  box-shadow: var(--shadow-soft);
}

.login-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.login-subtitle {
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 20px;
}

.login-card label {
  font-size: 12px;
  display: block;
  margin-bottom: 4px;
  color: var(--text-muted);
}

.login-card input {
  width: 100%;
  padding: 8px 10px;
  border-radius: 999px;
  border: 1px solid var(--border-subtle);
  font-size: 13px;
  margin-bottom: 10px;
}

.login-helper {
  font-size: 11px;
  color: var(--text-muted);
  margin-top: 8px;
  text-align: center;
}

/* 헤더 */
.app-header {
  height: 56px;
  border-bottom: 1px solid var(--border-subtle);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, #eff6ff, #faf5ff);

  /* 여기부터 고정용 속성 */
  position: sticky;
  top: 0;
  z-index: 50;  /* 중앙 내용보다 위에 보이도록 */
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-logo {
  width: 28px;
  height: 28px;
  border-radius: 10px;
  background: radial-gradient(circle at 30% 20%, #60a5fa, #4f46e5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  font-weight: 700;
}

.brand-text-main {
  font-size: 15px;
  font-weight: 700;
}

.brand-text-sub {
  font-size: 11px;
  color: var(--text-muted);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
}

.avatar {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
}

/* 상단 툴바 */
.toolbar {
  height: 42px;
  padding: 0 20px;
  border-bottom: 1px solid var(--border-subtle);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;

  /* 헤더 아래에 고정 */
  position: relative;
  top: 12px;   /* 헤더 높이만큼 아래 */
  z-index: 40;
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
}

.toolbar-label {
  font-size: 11px;
  color: var(--text-muted);
}

.toolbar-value {
  font-weight: 600;
}

.toolbar-divider {
  width: 1px;
  height: 16px;
  background: #e5e7eb;
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-muted);
}

.toolbar-right button {
  border-radius: 8px;
  background: #f3f4f6;
  padding-inline: 8px;
  min-width: 30px;
}

.toolbar-right button.active {
  background: var(--primary);
  color: #ffffff;
}

/* 메인 레이아웃 */
.app-main {
  padding: 12px 16px 16px;
  background: linear-gradient(180deg, #f9fafb, #eff6ff);
  font-size: calc(var(--font-base) * var(--font-scale));
}

.main-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1.15fr) 260px;
  gap: 12px;
}

/* 카드 / 공통 */
.card {
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  border: 1px solid rgba(148, 163, 184, 0.25);
  padding: 12px;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.card-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 6px;
}

.card-title {
  font-size: 13px;
  font-weight: 600;
}

.card-subtitle {
  font-size: 11px;
  color: var(--text-muted);
  margin-top: 2px;
}

/* 좌측 패널: 화면에 고정 + 내부 스크롤 */
.left-panel {
  position: sticky;
  top: calc(56px + 42px + 8px); /* 헤더 + 툴바 + 약간 여백 */
  align-self: flex-start;
  height: calc(100vh - (56px + 42px) - 16px);
  max-height: calc(100vh - (56px + 42px) - 16px);
}

/* 원문 콘텐츠: 좌측 패널 안에서만 스크롤 */
.doc-content {
  margin-top: 4px;
  padding: 10px;
  border-radius: 12px;
  background: var(--bg-muted);
  border: 1px solid #e5e7eb;
  overflow-y: auto;
  flex: 1 1;
  line-height: 1.55;
  white-space: pre-wrap;
}

/* 필드 그룹 */
.field-group {
  margin-bottom: 8px;
  padding: 8px;
  border-radius: 8px;
  background: var(--bg-muted);
  border: 1px solid #e5e7eb;
}

.field-label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.field-label {
  font-size: 11px;
  color: var(--text-muted);
}

.field-label-ghost {
  font-size: 11px;
  color: var(--text-muted);
  font-style: italic;
}

textarea {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 6px 8px;
  font-size: calc(0.85rem * var(--font-scale));
  resize: vertical;
  min-height: 50px;
  background: #ffffff;
  line-height: 1.5;
}

textarea:focus {
  outline: 2px solid var(--primary-soft);
  border-color: var(--primary);
}

.btn-row {
  margin-top: 6px;
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}

.pass-card {
  margin-top: 4px;
}

.result-text {
  font-size: 12px;
  color: #4b5563;
  margin-bottom: 6px;
}

.pass-status {
  margin-top: 6px;
  font-size: 11px;
  color: #16a34a;
  display: none;
}

.edit-status {
  margin-top: 4px;
  font-size: 11px;
  color: #ea580c;
  display: none;
}

/* 사이드바 */
.sidebar {
  display: flex;
  flex-direction: column;
  gap: 10px;

  position: sticky;
  top: calc(56px + 42px + 8px); /* 헤더 + 툴바 + 여백 */
  align-self: flex-start;
  max-height: calc(100vh - (56px + 42px) - 16px);
}

/* 우측 첫 번째 카드: viewport 높이에 맞추고 내부 목록만 스크롤 */
.sidebar-main {
  display: flex;
  flex-direction: column;
  flex: 1 1;        /* sidebar 안에서 남은 높이 대부분 사용 */
  max-height: 100%;
}
.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  margin-bottom: 4px;
}

.sidebar-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px;
  border-radius: 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

/* 문제 목록 아이템 */
.list-item {
  border-radius: 10px;
  padding: 7px 8px;
  margin-bottom: 6px;
  background: #ffffff;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  transition: background 0.15s ease, border-color 0.15s ease,
    transform 0.05s ease;
}

.list-item:hover {
  background: #eff6ff;
}

.list-item.active {
  border-color: var(--primary);
  background: #dbeafe;
  transform: translateY(-1px);
}

.list-item-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
}

.list-doc-id {
  font-weight: 600;
  font-size: 11px;
  color: #111827;
}

.list-meta {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: var(--text-muted);
}

.badge-status {
  border-radius: 999px;
  padding: 2px 6px;
  background: #e5e7eb;
  font-size: 10px;
}

.badge-status.done {
  background: #dcfce7;
  color: #166534;
}

.badge-status.todo {
  background: #fee2e2;
  color: #b91c1c;
}

.badge-status.edited {
  background: #dbeafe;
  color: #1e40af;
}

.badge-status.review {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #f59e0b;
}

/* 가이드 카드 */
.guide-card {
  font-size: 11px;
  gap: 6px;
}

.guide-card ul {
  margin-left: 14px;
  color: #4b5563;
  line-height: 1.4;
}

/* 반응형 */
@media (max-width: 1100px) {
  .main-layout {
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.2fr) 230px;
  }
}

@media (max-width: 900px) {
  .main-layout {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto auto auto;
  }

  .sidebar {
    order: -1;
    position: static;   /* ← 추가 */
    max-height: none;   /* ← 추가 */
  }

  .left-panel {
    position: static;
    height: auto;
    max-height: none;
  }

  .sidebar-main {
    max-height: none;
  }

  .doc-content {
    max-height: 60vh;
  }
}

/* ========================================
   문서 검색 UI 스타일
   ======================================== */
.search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  border-radius: 8px 8px 0 0;
}

.search-input {
  flex: 1 1;
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: calc(0.75rem * var(--font-scale));
  background: #ffffff;
}

.search-input:focus {
  outline: 2px solid var(--primary-soft);
  border-color: var(--primary);
}

.search-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.search-count {
  font-size: calc(0.7rem * var(--font-scale));
  color: var(--text-muted);
  min-width: 40px;
  text-align: center;
}

.search-btn {
  padding: 4px 8px;
  background: #e5e7eb;
  border: none;
  border-radius: 4px;
  font-size: calc(0.7rem * var(--font-scale));
  cursor: pointer;
  transition: background 0.15s ease;
}

.search-btn:hover {
  background: #d1d5db;
}

.search-btn:active {
  transform: translateY(1px);
}

/* 검색 하이라이트 스타일 */
.doc-content mark {
  background: #fef08a;
  color: inherit;
  padding: 2px 0;
  border-radius: 2px;
}

.doc-content mark.current {
  background: #fbbf24;
  font-weight: 600;
  box-shadow: 0 0 0 2px #f59e0b;
}

/* ========================================
   MRCR 탭 UI 스타일
   ======================================== */
.doc-tabs {
  display: none; /* 기본 숨김, MRCR일 때만 표시 */
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--bg-panel, #fff);
  border-bottom: 1px solid var(--border, #e5e7eb);
}

.tab-btn {
  padding: 0.5rem 1rem;
  background: transparent;
  border: 1px solid var(--border, #e5e7eb);
  border-radius: 6px;
  cursor: pointer;
  font-size: calc(0.875rem * var(--font-scale));
  font-weight: 500;
  color: var(--text-secondary, #6b7280);
  transition: all 0.2s;
}

.tab-btn:hover {
  background: var(--bg-hover, #f9fafb);
  color: var(--text-primary, #111827);
}

.tab-btn.active {
  background: var(--primary, #2563eb);
  color: white;
  border-color: var(--primary, #2563eb);
}

/* ========================================
   검토 요청 UI 스타일
   ======================================== */
.review-section {
  margin-top: 2rem;
}

.section-divider {
  height: 1px;
  background: linear-gradient(to right, transparent, #e5e7eb, transparent);
  margin: 1.5rem 0;
}

.subsection-title {
  font-size: calc(0.875rem * var(--font-scale));
  font-weight: 600;
  color: var(--text-secondary, #6b7280);
  margin-bottom: 1rem;
}

.btn-pass {
  background: #0bf532;
  color: white;
  border: none;
  padding: 10px 18px;
  font-size: calc(0.875rem * var(--font-scale));
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-pass:hover {
  background: #06d94c;
}

.btn-warning {
  background: #f59e0b;
  color: white;
  border: none;
  padding: 10px 18px;
  font-size: calc(0.875rem * var(--font-scale));
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-warning:hover {
  background: #d97706;
}

.review-status {
  display: none;
  margin-top: 12px;
  padding: 12px;
  background: #fef3c7;
  color: #92400e;
  border-left: 4px solid #f59e0b;
  border-radius: 4px;
  font-size: calc(0.875rem * var(--font-scale));
}

/* 툴바 status chip에 노란색 추가 */
.chip-yellow {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #f59e0b;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: calc(0.75rem * var(--font-scale));
  font-weight: 600;
}

/* ========================================
   보기 그리드
   ======================================== */
.options-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.option-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border: 1px solid var(--border-subtle);
  border-radius: 6px;
  padding: 8px 10px;
  background: #fefce8;  /* 연한 노란색 배경 */
  transition: all 0.2s;
}

.option-box:hover {
  background: #fef9c3;
  border-color: #fcd34d;
}

.option-label {
  flex-shrink: 0;
  min-width: 50px;
  font-size: calc(0.7rem * var(--font-scale));
  font-weight: 700;
  color: #92400e;
  padding-top: 4px;
}

.option-textarea {
  flex: 1 1;
  min-height: 40px;
  border: 1px solid #fde68a;
  padding: 6px 8px;
  font-size: calc(0.8rem * var(--font-scale));
  border-radius: 4px;
  background: white;
  font-family: inherit;
  resize: vertical;
  transition: all 0.2s;
  line-height: 1.4;
}

.option-textarea:focus {
  outline: none;
  border-color: #fbbf24;
  box-shadow: 0 0 0 2px #fef3c7;
}

/* ========================================
   COT 그리드
   ======================================== */
.cot-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cot-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border: 1px solid var(--border-subtle);
  border-radius: 6px;
  padding: 8px 10px;
  background: #dbeafe;  /* 연한 파란색 배경 */
  transition: all 0.2s;
}

.cot-box:hover {
  background: #bfdbfe;
  border-color: #60a5fa;
}

.cot-label {
  flex-shrink: 0;
  min-width: 50px;
  font-size: calc(0.7rem * var(--font-scale));
  font-weight: 700;
  color: #1e40af;
  padding-top: 4px;
}

.cot-textarea {
  flex: 1 1;
  min-height: 50px;
  border: 1px solid #93c5fd;
  padding: 6px 8px;
  font-size: calc(0.8rem * var(--font-scale));
  border-radius: 4px;
  background: white;
  font-family: inherit;
  resize: vertical;
  transition: all 0.2s;
  line-height: 1.5;
}

.cot-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px #dbeafe;
}

.search-mark {
  background-color: #fde68a;
}

.search-mark.current {
  background-color: #f59e0b;
}

.doc-text {
  display: block;
  white-space: pre-wrap;
}

.badge-status {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  display: inline-block;
}

/* 대기 */
.status-대기 {
  background-color: #f3f4f6;
  color: #374151;
}

/* 통과 */
.status-통과 {
  background-color: #dcfce7;
  color: #166534;
}

/* 수정됨 */
.status-수정됨,
.status-수정 {
  background-color: #fef9c3;
  color: #854d0e;
}

/* 검토 요청 */
.status-검토\\ 요청 {
  background-color: #fee2e2;
  color: #991b1b;
}`, "",{"version":3,"sources":["webpack://./src/pages/eval-worker/evlt/bufs_style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,gDAAgD;;EAEhD,iBAAiB;EACjB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;cACY;EACZ,qDAAqD;EACrD,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;6CAE6C;AAC7C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd;wBACsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;EACtC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB;;AAEA,OAAO;AACP;EACE,YAAY;EACZ,6CAA6C;EAC7C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oDAAoD;;EAEpD,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,WAAW,GAAG,oBAAoB;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gEAAgE;EAChE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,eAAe;EACf,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;;EAEnB,cAAc;EACd,kBAAkB;EAClB,SAAS,IAAI,eAAe;EAC5B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,uBAAuB;EACvB,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,gEAAgE;EAChE,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,4BAA4B,EAAE,oBAAoB;EAClD,sBAAsB;EACtB,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,SAAO;EACP,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,gBAAgB;EAChB,4BAA4B,EAAE,iBAAiB;EAC/C,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO,SAAS,6BAA6B;EAC7C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;wBACsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE;IACE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,kCAAkC;EACpC;;EAEA;IACE,SAAS;IACT,gBAAgB,IAAI,SAAS;IAC7B,gBAAgB,IAAI,SAAS;EAC/B;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2CAA2C;EAC3C,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;6CAE6C;AAC7C;EACE,aAAa,EAAE,uBAAuB;EACtC,WAAW;EACX,qBAAqB;EACrB,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,qCAAqC;AACvC;;AAEA;;6CAE6C;AAC7C;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wEAAwE;EACxE,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB,GAAG,cAAc;EACpC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB,GAAG,cAAc;EACpC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,OAAO;AACP;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,OAAO;AACP;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,QAAQ;AACR;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".app-shell {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n}\r\n\r\n:root {\r\n  --bg-body: #f3f4f6;\r\n  --bg-shell: #ffffff;\r\n  --bg-card: #ffffff;\r\n  --bg-muted: #f9fafb;\r\n  --border-subtle: #e5e7eb;\r\n  --primary: #2563eb;\r\n  --primary-soft: #dbeafe;\r\n  --primary-strong: #1d4ed8;\r\n  --danger: #ef4444;\r\n  --text-main: #111827;\r\n  --text-muted: #6b7280;\r\n  --radius-lg: 16px;\r\n  --radius-md: 12px;\r\n  --shadow-soft: 0 18px 45px rgba(15, 23, 42, 0.1);\r\n\r\n  --font-base: 14px;\r\n  --font-scale: 1;\r\n}\r\n\r\n/* 폰트 크기 모드 (A-, A, A+) */\r\n[data-font-size=\"sm\"] {\r\n  --font-scale: 0.9;\r\n}\r\n[data-font-size=\"md\"] {\r\n  --font-scale: 1;\r\n}\r\n[data-font-size=\"lg\"] {\r\n  --font-scale: 1.1;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nbody {\r\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\",\r\n    sans-serif;\r\n  background: linear-gradient(180deg, #f9fafb, #eff6ff);\r\n  min-height: 100vh;\r\n  color: var(--text-main);\r\n}\r\n\r\n/* ========================================\r\n   로딩 오버레이\r\n   ======================================== */\r\n.loading-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: none;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 9999;\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.loading-overlay.show {\r\n  display: flex;\r\n}\r\n\r\n.loading-spinner {\r\n  width: 60px;\r\n  height: 60px;\r\n  border: 4px solid rgba(255, 255, 255, 0.3);\r\n  border-top-color: #fff;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.loading-text {\r\n  position: absolute;\r\n  margin-top: 100px;\r\n  color: #fff;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* 공통 버튼 스타일 */\r\nbutton {\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  border-radius: 999px;\r\n  padding: 6px 12px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n  background: #e5e7eb;\r\n  color: #111827;\r\n  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease,\r\n    transform 0.05s ease;\r\n}\r\n\r\nbutton:hover {\r\n  background: #d1d5db;\r\n}\r\n\r\nbutton:active {\r\n  transform: translateY(1px);\r\n}\r\n\r\n.btn-primary {\r\n  background: var(--primary);\r\n  color: #ffffff;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: var(--primary-strong);\r\n  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.35);\r\n}\r\n\r\n.btn-ghost {\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* 칩 / 배지 */\r\n.chip {\r\n  border-radius: 999px;\r\n  padding: 3px 10px;\r\n  font-size: 11px;\r\n  background: #eff6ff;\r\n  color: #1d4ed8;\r\n}\r\n\r\n.chip-green {\r\n  background: #ecfdf3;\r\n  color: #15803d;\r\n}\r\n\r\n.chip-gray {\r\n  background: #f3f4f6;\r\n  color: #4b5563;\r\n}\r\n\r\n.chip-blue {\r\n  background: #dbeafe;\r\n  color: #1e40af;\r\n}\r\n\r\n/* 앱 쉘: 프레임 없이 전체 화면 사용 */\r\n.app-shell {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  min-height: 100vh;\r\n  background: var(--bg-shell);\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* 로그인 뷰 (화면 중앙 카드) */\r\n.login-view {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #dbeafe, #fef9c3);\r\n}\r\n\r\n.login-card {\r\n  width: 360px;\r\n  border-radius: 20px;\r\n  padding: 24px 24px 20px;\r\n  background: #ffffff;\r\n  box-shadow: var(--shadow-soft);\r\n}\r\n\r\n.login-title {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.login-subtitle {\r\n  font-size: 12px;\r\n  color: var(--text-muted);\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.login-card label {\r\n  font-size: 12px;\r\n  display: block;\r\n  margin-bottom: 4px;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.login-card input {\r\n  width: 100%;\r\n  padding: 8px 10px;\r\n  border-radius: 999px;\r\n  border: 1px solid var(--border-subtle);\r\n  font-size: 13px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.login-helper {\r\n  font-size: 11px;\r\n  color: var(--text-muted);\r\n  margin-top: 8px;\r\n  text-align: center;\r\n}\r\n\r\n/* 헤더 */\r\n.app-header {\r\n  height: 56px;\r\n  border-bottom: 1px solid var(--border-subtle);\r\n  padding: 0 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background: linear-gradient(90deg, #eff6ff, #faf5ff);\r\n\r\n  /* 여기부터 고정용 속성 */\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 50;  /* 중앙 내용보다 위에 보이도록 */\r\n}\r\n\r\n.brand {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.brand-logo {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 10px;\r\n  background: radial-gradient(circle at 30% 20%, #60a5fa, #4f46e5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n}\r\n\r\n.brand-text-main {\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n}\r\n\r\n.brand-text-sub {\r\n  font-size: 11px;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.header-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 12px;\r\n}\r\n\r\n.avatar {\r\n  width: 26px;\r\n  height: 26px;\r\n  border-radius: 999px;\r\n  background: #e5e7eb;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #4b5563;\r\n}\r\n\r\n/* 상단 툴바 */\r\n.toolbar {\r\n  height: 42px;\r\n  padding: 0 20px;\r\n  border-bottom: 1px solid var(--border-subtle);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background: #ffffff;\r\n\r\n  /* 헤더 아래에 고정 */\r\n  position: relative;\r\n  top: 12px;   /* 헤더 높이만큼 아래 */\r\n  z-index: 40;\r\n}\r\n\r\n.toolbar-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 12px;\r\n}\r\n\r\n.toolbar-label {\r\n  font-size: 11px;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.toolbar-value {\r\n  font-weight: 600;\r\n}\r\n\r\n.toolbar-divider {\r\n  width: 1px;\r\n  height: 16px;\r\n  background: #e5e7eb;\r\n}\r\n\r\n.toolbar-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 12px;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.toolbar-right button {\r\n  border-radius: 8px;\r\n  background: #f3f4f6;\r\n  padding-inline: 8px;\r\n  min-width: 30px;\r\n}\r\n\r\n.toolbar-right button.active {\r\n  background: var(--primary);\r\n  color: #ffffff;\r\n}\r\n\r\n/* 메인 레이아웃 */\r\n.app-main {\r\n  padding: 12px 16px 16px;\r\n  background: linear-gradient(180deg, #f9fafb, #eff6ff);\r\n  font-size: calc(var(--font-base) * var(--font-scale));\r\n}\r\n\r\n.main-layout {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1.15fr) 260px;\r\n  gap: 12px;\r\n}\r\n\r\n/* 카드 / 공통 */\r\n.card {\r\n  background: var(--bg-card);\r\n  border-radius: var(--radius-lg);\r\n  border: 1px solid rgba(148, 163, 184, 0.25);\r\n  padding: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n}\r\n\r\n.card-header {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.card-title {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n}\r\n\r\n.card-subtitle {\r\n  font-size: 11px;\r\n  color: var(--text-muted);\r\n  margin-top: 2px;\r\n}\r\n\r\n/* 좌측 패널: 화면에 고정 + 내부 스크롤 */\r\n.left-panel {\r\n  position: sticky;\r\n  top: calc(56px + 42px + 8px); /* 헤더 + 툴바 + 약간 여백 */\r\n  align-self: flex-start;\r\n  height: calc(100vh - (56px + 42px) - 16px);\r\n  max-height: calc(100vh - (56px + 42px) - 16px);\r\n}\r\n\r\n/* 원문 콘텐츠: 좌측 패널 안에서만 스크롤 */\r\n.doc-content {\r\n  margin-top: 4px;\r\n  padding: 10px;\r\n  border-radius: 12px;\r\n  background: var(--bg-muted);\r\n  border: 1px solid #e5e7eb;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n  line-height: 1.55;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n/* 필드 그룹 */\r\n.field-group {\r\n  margin-bottom: 8px;\r\n  padding: 8px;\r\n  border-radius: 8px;\r\n  background: var(--bg-muted);\r\n  border: 1px solid #e5e7eb;\r\n}\r\n\r\n.field-label-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.field-label {\r\n  font-size: 11px;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.field-label-ghost {\r\n  font-size: 11px;\r\n  color: var(--text-muted);\r\n  font-style: italic;\r\n}\r\n\r\ntextarea {\r\n  width: 100%;\r\n  border-radius: 8px;\r\n  border: 1px solid #d1d5db;\r\n  padding: 6px 8px;\r\n  font-size: calc(0.85rem * var(--font-scale));\r\n  resize: vertical;\r\n  min-height: 50px;\r\n  background: #ffffff;\r\n  line-height: 1.5;\r\n}\r\n\r\ntextarea:focus {\r\n  outline: 2px solid var(--primary-soft);\r\n  border-color: var(--primary);\r\n}\r\n\r\n.btn-row {\r\n  margin-top: 6px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 6px;\r\n}\r\n\r\n.pass-card {\r\n  margin-top: 4px;\r\n}\r\n\r\n.result-text {\r\n  font-size: 12px;\r\n  color: #4b5563;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.pass-status {\r\n  margin-top: 6px;\r\n  font-size: 11px;\r\n  color: #16a34a;\r\n  display: none;\r\n}\r\n\r\n.edit-status {\r\n  margin-top: 4px;\r\n  font-size: 11px;\r\n  color: #ea580c;\r\n  display: none;\r\n}\r\n\r\n/* 사이드바 */\r\n.sidebar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n\r\n  position: sticky;\r\n  top: calc(56px + 42px + 8px); /* 헤더 + 툴바 + 여백 */\r\n  align-self: flex-start;\r\n  max-height: calc(100vh - (56px + 42px) - 16px);\r\n}\r\n\r\n/* 우측 첫 번째 카드: viewport 높이에 맞추고 내부 목록만 스크롤 */\r\n.sidebar-main {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;        /* sidebar 안에서 남은 높이 대부분 사용 */\r\n  max-height: 100%;\r\n}\r\n.sidebar-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-size: 12px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.sidebar-list {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 8px;\r\n  border-radius: 14px;\r\n  background: #f9fafb;\r\n  border: 1px solid #e5e7eb;\r\n}\r\n\r\n/* 문제 목록 아이템 */\r\n.list-item {\r\n  border-radius: 10px;\r\n  padding: 7px 8px;\r\n  margin-bottom: 6px;\r\n  background: #ffffff;\r\n  border: 1px solid transparent;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  transition: background 0.15s ease, border-color 0.15s ease,\r\n    transform 0.05s ease;\r\n}\r\n\r\n.list-item:hover {\r\n  background: #eff6ff;\r\n}\r\n\r\n.list-item.active {\r\n  border-color: var(--primary);\r\n  background: #dbeafe;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.list-item-top {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.list-doc-id {\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n  color: #111827;\r\n}\r\n\r\n.list-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 10px;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.badge-status {\r\n  border-radius: 999px;\r\n  padding: 2px 6px;\r\n  background: #e5e7eb;\r\n  font-size: 10px;\r\n}\r\n\r\n.badge-status.done {\r\n  background: #dcfce7;\r\n  color: #166534;\r\n}\r\n\r\n.badge-status.todo {\r\n  background: #fee2e2;\r\n  color: #b91c1c;\r\n}\r\n\r\n.badge-status.edited {\r\n  background: #dbeafe;\r\n  color: #1e40af;\r\n}\r\n\r\n.badge-status.review {\r\n  background: #fef3c7;\r\n  color: #92400e;\r\n  border: 1px solid #f59e0b;\r\n}\r\n\r\n/* 가이드 카드 */\r\n.guide-card {\r\n  font-size: 11px;\r\n  gap: 6px;\r\n}\r\n\r\n.guide-card ul {\r\n  margin-left: 14px;\r\n  color: #4b5563;\r\n  line-height: 1.4;\r\n}\r\n\r\n/* 반응형 */\r\n@media (max-width: 1100px) {\r\n  .main-layout {\r\n    grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.2fr) 230px;\r\n  }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .main-layout {\r\n    grid-template-columns: minmax(0, 1fr);\r\n    grid-template-rows: auto auto auto;\r\n  }\r\n\r\n  .sidebar {\r\n    order: -1;\r\n    position: static;   /* ← 추가 */\r\n    max-height: none;   /* ← 추가 */\r\n  }\r\n\r\n  .left-panel {\r\n    position: static;\r\n    height: auto;\r\n    max-height: none;\r\n  }\r\n\r\n  .sidebar-main {\r\n    max-height: none;\r\n  }\r\n\r\n  .doc-content {\r\n    max-height: 60vh;\r\n  }\r\n}\r\n\r\n/* ========================================\r\n   문서 검색 UI 스타일\r\n   ======================================== */\r\n.search-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 10px;\r\n  background: #f9fafb;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  border-radius: 8px 8px 0 0;\r\n}\r\n\r\n.search-input {\r\n  flex: 1;\r\n  padding: 6px 10px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  font-size: calc(0.75rem * var(--font-scale));\r\n  background: #ffffff;\r\n}\r\n\r\n.search-input:focus {\r\n  outline: 2px solid var(--primary-soft);\r\n  border-color: var(--primary);\r\n}\r\n\r\n.search-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.search-count {\r\n  font-size: calc(0.7rem * var(--font-scale));\r\n  color: var(--text-muted);\r\n  min-width: 40px;\r\n  text-align: center;\r\n}\r\n\r\n.search-btn {\r\n  padding: 4px 8px;\r\n  background: #e5e7eb;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: calc(0.7rem * var(--font-scale));\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.search-btn:hover {\r\n  background: #d1d5db;\r\n}\r\n\r\n.search-btn:active {\r\n  transform: translateY(1px);\r\n}\r\n\r\n/* 검색 하이라이트 스타일 */\r\n.doc-content mark {\r\n  background: #fef08a;\r\n  color: inherit;\r\n  padding: 2px 0;\r\n  border-radius: 2px;\r\n}\r\n\r\n.doc-content mark.current {\r\n  background: #fbbf24;\r\n  font-weight: 600;\r\n  box-shadow: 0 0 0 2px #f59e0b;\r\n}\r\n\r\n/* ========================================\r\n   MRCR 탭 UI 스타일\r\n   ======================================== */\r\n.doc-tabs {\r\n  display: none; /* 기본 숨김, MRCR일 때만 표시 */\r\n  gap: 0.5rem;\r\n  padding: 0.75rem 1rem;\r\n  background: var(--bg-panel, #fff);\r\n  border-bottom: 1px solid var(--border, #e5e7eb);\r\n}\r\n\r\n.tab-btn {\r\n  padding: 0.5rem 1rem;\r\n  background: transparent;\r\n  border: 1px solid var(--border, #e5e7eb);\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: calc(0.875rem * var(--font-scale));\r\n  font-weight: 500;\r\n  color: var(--text-secondary, #6b7280);\r\n  transition: all 0.2s;\r\n}\r\n\r\n.tab-btn:hover {\r\n  background: var(--bg-hover, #f9fafb);\r\n  color: var(--text-primary, #111827);\r\n}\r\n\r\n.tab-btn.active {\r\n  background: var(--primary, #2563eb);\r\n  color: white;\r\n  border-color: var(--primary, #2563eb);\r\n}\r\n\r\n/* ========================================\r\n   검토 요청 UI 스타일\r\n   ======================================== */\r\n.review-section {\r\n  margin-top: 2rem;\r\n}\r\n\r\n.section-divider {\r\n  height: 1px;\r\n  background: linear-gradient(to right, transparent, #e5e7eb, transparent);\r\n  margin: 1.5rem 0;\r\n}\r\n\r\n.subsection-title {\r\n  font-size: calc(0.875rem * var(--font-scale));\r\n  font-weight: 600;\r\n  color: var(--text-secondary, #6b7280);\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.btn-pass {\r\n  background: #0bf532;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 18px;\r\n  font-size: calc(0.875rem * var(--font-scale));\r\n  font-weight: 600;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.btn-pass:hover {\r\n  background: #06d94c;\r\n}\r\n\r\n.btn-warning {\r\n  background: #f59e0b;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 18px;\r\n  font-size: calc(0.875rem * var(--font-scale));\r\n  font-weight: 600;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.btn-warning:hover {\r\n  background: #d97706;\r\n}\r\n\r\n.review-status {\r\n  display: none;\r\n  margin-top: 12px;\r\n  padding: 12px;\r\n  background: #fef3c7;\r\n  color: #92400e;\r\n  border-left: 4px solid #f59e0b;\r\n  border-radius: 4px;\r\n  font-size: calc(0.875rem * var(--font-scale));\r\n}\r\n\r\n/* 툴바 status chip에 노란색 추가 */\r\n.chip-yellow {\r\n  background: #fef3c7;\r\n  color: #92400e;\r\n  border: 1px solid #f59e0b;\r\n  padding: 4px 12px;\r\n  border-radius: 12px;\r\n  font-size: calc(0.75rem * var(--font-scale));\r\n  font-weight: 600;\r\n}\r\n\r\n/* ========================================\r\n   보기 그리드\r\n   ======================================== */\r\n.options-grid {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.option-box {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  border: 1px solid var(--border-subtle);\r\n  border-radius: 6px;\r\n  padding: 8px 10px;\r\n  background: #fefce8;  /* 연한 노란색 배경 */\r\n  transition: all 0.2s;\r\n}\r\n\r\n.option-box:hover {\r\n  background: #fef9c3;\r\n  border-color: #fcd34d;\r\n}\r\n\r\n.option-label {\r\n  flex-shrink: 0;\r\n  min-width: 50px;\r\n  font-size: calc(0.7rem * var(--font-scale));\r\n  font-weight: 700;\r\n  color: #92400e;\r\n  padding-top: 4px;\r\n}\r\n\r\n.option-textarea {\r\n  flex: 1;\r\n  min-height: 40px;\r\n  border: 1px solid #fde68a;\r\n  padding: 6px 8px;\r\n  font-size: calc(0.8rem * var(--font-scale));\r\n  border-radius: 4px;\r\n  background: white;\r\n  font-family: inherit;\r\n  resize: vertical;\r\n  transition: all 0.2s;\r\n  line-height: 1.4;\r\n}\r\n\r\n.option-textarea:focus {\r\n  outline: none;\r\n  border-color: #fbbf24;\r\n  box-shadow: 0 0 0 2px #fef3c7;\r\n}\r\n\r\n/* ========================================\r\n   COT 그리드\r\n   ======================================== */\r\n.cot-grid {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.cot-box {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  border: 1px solid var(--border-subtle);\r\n  border-radius: 6px;\r\n  padding: 8px 10px;\r\n  background: #dbeafe;  /* 연한 파란색 배경 */\r\n  transition: all 0.2s;\r\n}\r\n\r\n.cot-box:hover {\r\n  background: #bfdbfe;\r\n  border-color: #60a5fa;\r\n}\r\n\r\n.cot-label {\r\n  flex-shrink: 0;\r\n  min-width: 50px;\r\n  font-size: calc(0.7rem * var(--font-scale));\r\n  font-weight: 700;\r\n  color: #1e40af;\r\n  padding-top: 4px;\r\n}\r\n\r\n.cot-textarea {\r\n  flex: 1;\r\n  min-height: 50px;\r\n  border: 1px solid #93c5fd;\r\n  padding: 6px 8px;\r\n  font-size: calc(0.8rem * var(--font-scale));\r\n  border-radius: 4px;\r\n  background: white;\r\n  font-family: inherit;\r\n  resize: vertical;\r\n  transition: all 0.2s;\r\n  line-height: 1.5;\r\n}\r\n\r\n.cot-textarea:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 2px #dbeafe;\r\n}\r\n\r\n.search-mark {\r\n  background-color: #fde68a;\r\n}\r\n\r\n.search-mark.current {\r\n  background-color: #f59e0b;\r\n}\r\n\r\n.doc-text {\r\n  display: block;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.badge-status {\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  line-height: 1.4;\r\n  display: inline-block;\r\n}\r\n\r\n/* 대기 */\r\n.status-대기 {\r\n  background-color: #f3f4f6;\r\n  color: #374151;\r\n}\r\n\r\n/* 통과 */\r\n.status-통과 {\r\n  background-color: #dcfce7;\r\n  color: #166534;\r\n}\r\n\r\n/* 수정됨 */\r\n.status-수정됨,\r\n.status-수정 {\r\n  background-color: #fef9c3;\r\n  color: #854d0e;\r\n}\r\n\r\n/* 검토 요청 */\r\n.status-검토\\ 요청 {\r\n  background-color: #fee2e2;\r\n  color: #991b1b;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
